/* istanbul ignore file */
import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import { useSubmit } from 'framework/utils';
import { useVacancyGroupService } from 'domain/shared/newVacancy';
import { useShowContext } from 'framework/show';

const ApproveVacancyCancellationRequestButton = ({
  setGeneralContextData,
  setModalOpen,
}: {
  setGeneralContextData: () => {};
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { approveVacancyCancellation } = useVacancyGroupService();

  const { data } = useShowContext();
  const { id } = data.getData();

  const { onSubmit } = useSubmit({
    submitMethod: () => approveVacancyCancellation(id!),
    afterSubmit: {
      successMessage: 'Vacancy cancellation request has been successfully approved.',
      errorMessage: "Can't approve cancellation request.",
      execute: () => {
        if (setGeneralContextData) {
          setGeneralContextData();
        }
      },
    },
  });

  return (
    <Button
      onClick={() => {
        onSubmit();
        setModalOpen(false);
      }}
    >
      Approve
    </Button>
  );
};

export default ApproveVacancyCancellationRequestButton;
